import type { DoodleGuess, GameView, Stroke } from '@/api/types';

function parseGuess(data: unknown): DoodleGuess | null {
  const g = data as Partial<DoodleGuess> | null;
  if (!g || typeof g.player_id !== 'string' || typeof g.text !== 'string') return null;
  return { player_id: g.player_id, text: g.text, correct: !!g.correct };
}

/**
 * Fold an ephemeral `game.effect` into the cached GameView so components can
 * render purely from the view. The next `game.state` replaces it anyway.
 */
export function applyEffect(view: GameView | undefined, kind: string, data: unknown): GameView | undefined {
  if (!view) return view;
  if (view.type === 'charades') {
    // Wrong typed guesses are broadcast as effects (SPEC_V3 §1).
    if (kind !== 'guess') return view;
    const guess = parseGuess(data);
    if (!guess) return view;
    return { ...view, data: { ...view.data, guesses: [...view.data.guesses, guess].slice(-50) } };
  }
  if (view.type !== 'doodle') return view;
  const d = view.data;
  if (kind === 'stroke') {
    const stroke = (data as { stroke?: Stroke } | null)?.stroke;
    if (!stroke || !Array.isArray(stroke.points)) return view;
    return { ...view, data: { ...d, strokes: [...d.strokes, stroke] } };
  }
  if (kind === 'clear') {
    return { ...view, data: { ...d, strokes: [] } };
  }
  if (kind === 'guess') {
    const guess = parseGuess(data);
    if (!guess) return view;
    return { ...view, data: { ...d, guesses: [...d.guesses, guess].slice(-50) } };
  }
  return view;
}
